import { useContext, useEffect, useRef, useState } from "react";

import { Link, useLocation, useParams } from "react-router-dom";

import "./Header.css";
import { ReactComponent as CartIcon } from "../../assets/icons/cart.svg";
import { ReactComponent as MenuIcon } from "../../assets/icons/menu.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as ExpandIcon } from "../../assets/icons/expand.svg";
import { ReactComponent as Logo } from "../../assets/icons/logoWithUkr.svg";
import Logo1 from "../../assets/icons/logoWithUkr.svg";
import { ReactComponent as UKR } from "../../assets/icons/ukr.svg";
import Floater from "../Floater/Floater";
import Button from "../../UI/Button/Button";
import Cover from "../../UI/Cover/Cover";
import { connect } from "react-redux";
import { stateType } from "../../store";
import {
  cartItem,
  extrasCartItem,
  service_types
} from "../../state_management/reducers/cart";
import { removeFromCart } from "../../state_management/actions";
import { formatCategoryName } from "../../App";
import {
  add_shipping_info_params,
  view_cart_ga
} from "../../utilities/analytics";
import { currency, getCurrency, getServiceLink } from "../../utilities/misc";
import { domain as d } from "../../settings";
import { json } from "../../translation_json";
import { locale } from "../../translate";
import { parseGACart } from "../../utilities/cartUtilities";
import {
  CartTotalContext,
  CategoryContext,
  LocaleContext
} from "../../AppProvider";
import useDeviceWidth from "../../utilities/useDeviceWidth";
import BenefitsHeader from "./BenefitsHeader";

const Header = ({
  cart,
  extras,
  removeFromCart
}: {
  cart: cartItem[];
  extras: extrasCartItem[];
  removeFromCart: (id: number, type: service_types) => void;
}) => {
  const { t, locale } = useContext(LocaleContext);
  const { serviceName } = useParams();
  const [cartTotal] = useContext(CartTotalContext);
  const floatRef = useRef<HTMLDivElement>(null);
  const listRef = useRef<HTMLDivElement>(null);
  const pricelistRef = useRef<HTMLDivElement>(null);
  const mountedRef = useRef(1);
  const { isMobile } = useDeviceWidth();

  const cartCombined = [...cart, ...extras];

  const getScrollHeight = () => {
    return Math.round(
      document.documentElement.scrollTop || document.body.scrollTop || 0
    );
  };

  const [categories] = useContext(CategoryContext);
  const [closeCategory, setCloseCategory] = useState(true);
  const [scrollHeight, setScrollHeight] = useState(getScrollHeight());
  const [showFloat, setShowFloat] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [timeoutId, setTimeoutId] = useState<number | undefined>();

  const { pathname } = useLocation();

  const open = (show: boolean = true) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    setShowFloat(show);
  };

  const location = useLocation();

  useEffect(() => {
    setShowFloat(false);
    if ((location.state as { fromHome: boolean })?.fromHome) {
      mountedRef.current = 0;
    }

    return () => {
      mountedRef.current = 0;
    };
  }, [location.state]);

  useEffect(() => {
    if (cart.length) {
      if (mountedRef.current > 0) {
        open();
        const copyTimeout = window.setTimeout(() => {
          if (mountedRef.current) {
            setShowFloat(false);
          }
        }, 3000);
        setTimeoutId(copyTimeout);
      }
    }
    mountedRef.current++;
  }, [JSON.stringify(cart)]);

  useEffect(() => {
    const outsideClick = (e: MouseEvent) => {
      if (
        !floatRef.current?.contains(e.target as Node) &&
        !listRef.current?.contains(e.target as Node) &&
        !pricelistRef.current?.contains(e.target as Node)
      ) {
        if (showFloat) setShowFloat(false);
        if (isOpen) setIsOpen(false);
        setCloseCategory(true);
      }
    };

    const scroll = () => {
      var scrollTop = getScrollHeight();

      setScrollHeight(scrollTop);
    };

    document.addEventListener(`click`, outsideClick);
    window.addEventListener(`scroll`, scroll);

    return () => {
      document.removeEventListener(`click`, outsideClick);
      window.removeEventListener(`scroll`, scroll);
    };
  }, []);

  const clickCategory = () => {
    window.scrollTo({ top: 0 });
    setCloseCategory(true);
  };

  const cartRoute = "/cart";
  const service_link = getServiceLink(locale);
  const domain = d(locale);

  return (
    <>
      <div className={`header ${closeCategory ? "closeCategory" : ""}`}>
        <div
          className={`showMd header_logo_holder flex1 center ${
            scrollHeight > 32 ? "scrolled" : ""
          }`}
        >
          <a href={`http://${domain}`}>
            <img src={Logo1} alt="" />
          </a>
        </div>
        <div
          className={`clean_bee_content  ${
            scrollHeight > 32 ? "scrolled" : ""
          }`}
        >
          <div className="header_icon center">
            {!isOpen ? (
              <MenuIcon
                className="showMd header_menu_icon"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowFloat(false);
                  setIsOpen(!isOpen);
                }}
              />
            ) : (
              <CloseIcon
                className="showMd header_menu_close_icon img_div_contain"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowFloat(false);
                  setIsOpen(!isOpen);
                }}
              />
            )}
          </div>
          <div className="header_logo_holder flex1">
            <a href={`http://${domain}`}>
              <Logo className="clLogo noShowMd" />
            </a>
          </div>
          <nav className="header_list_wrapper">
            <div
              onMouseOver={() => {
                if (isMobile) return;
                setCloseCategory(false);
              }}
              onMouseOut={() => {
                if (isMobile) return;
                setCloseCategory(true);
              }}
              onClick={() => {
                if (!isMobile) return;
                setCloseCategory((close) => !close);
              }}
              ref={pricelistRef}
              className="header_categories_drop_container"
            >
              <div className="header_categories_drop_wrapper">
                <Link to={`/${service_link}`}>
                  <span>
                    {t("Services and Pricelist")}{" "}
                    <ExpandIcon className="header_arrow" />
                  </span>
                </Link>
              </div>

              <div className="abs_header_categories_list">
                <ul
                  onClick={(e) => {
                    e.stopPropagation();
                    clickCategory();
                  }}
                  className="header_categories_list_wrapper scrollWheel"
                >
                  {categories ? (
                    categories
                      .sort((a, b) => (a.position || 0) - (b.position || 0))
                      .map((category, n) => (
                        <li key={n}>
                          <Link
                            className={`${
                              serviceName === formatCategoryName(category)
                                ? "active"
                                : ""
                            }`}
                            to={`/${service_link}/${formatCategoryName(
                              category,
                              false
                            )}`}
                            key={n}
                          >
                            {category.name}
                          </Link>
                        </li>
                      ))
                  ) : (
                    <div></div>
                  )}
                </ul>
              </div>
            </div>

            <HeaderList
              domain={domain}
              locale={locale}
              t={t}
              className="noShowMd"
            />
          </nav>
          {pathname !== cartRoute ? (
            <div className="header_icon">
              <div
                className="head_cart_icon_wrapper"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpen(false);
                  open(!showFloat);
                }}
              >
                <div className="float_indicator indicator">
                  {cartCombined.length}
                </div>
                <CartIcon />
              </div>
              {showFloat ? (
                <div
                  onClick={() => {
                    clearTimeout(timeoutId);
                  }}
                  ref={floatRef}
                >
                  <Floater className="header_cart_floater">
                    <div className="cartFloater flex1 fdCol">
                      {cartCombined.length ? (
                        <>
                          <div className="top scrollWheel">
                            {cartCombined.map((item, n) => {
                              const service = item.item;
                              return (
                                <div
                                  key={service.id}
                                  className="cartFloat_item_wrapper flex"
                                >
                                  <div className="img">
                                    <Cover className="">
                                      <img
                                        src={service.photo_path || ``}
                                        alt=""
                                      />
                                    </Cover>
                                  </div>
                                  <div className="details flex1">
                                    <div className="title med_text">
                                      {service.name}
                                    </div>
                                    <div className="quantity">
                                      {t("Quantity")}: {item.quantity}
                                    </div>
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        removeFromCart(service.id, item.type);
                                      }}
                                      className="remove fontBlue"
                                    >
                                      {t("remove")}
                                    </div>
                                  </div>
                                  <div className="total med_text">
                                    <div className="fontBlue">
                                      {currency(
                                        (
                                          item.quantity *
                                          item.item.price_with_discount
                                        ).toFixed(2),
                                        locale,
                                        item.parent_id === undefined &&
                                          item.item.type === "gift"
                                      )}
                                    </div>
                                    {service.discount ? (
                                      <div className="strike_through">
                                        {currency(
                                          (
                                            item.quantity * item.item.price
                                          ).toFixed(2),
                                          locale
                                        )}
                                      </div>
                                    ) : (
                                      ``
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                          <div className="fdCol bottom">
                            <div className="cartFloaterTotal">
                              <div className="total_label">{t("Total")}:</div>
                              <div className="fontBlue">
                                {currency(cartTotal.toFixed(2), locale)}
                              </div>
                            </div>
                            {location.pathname !== cartRoute && (
                              <div className="flex">
                                <Button
                                  onClick={() => {
                                    const parseCart: add_shipping_info_params["items"] =
                                      parseGACart({ cart, extras });

                                    setShowFloat(false);
                                    view_cart_ga({
                                      currency: getCurrency(),
                                      value: cartTotal,
                                      items: parseCart
                                    });
                                  }}
                                  size="sm"
                                  span
                                  linkObj={{ href: cartRoute }}
                                >
                                  {t("Proceed to Cart")}
                                </Button>
                              </div>
                            )}
                          </div>
                        </>
                      ) : (
                        <div />
                      )}
                    </div>
                  </Floater>
                </div>
              ) : (
                ``
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
        <div
          ref={listRef}
          className={`showMd clean_bee_content_inner ${
            isOpen ? `slide_content` : ``
          }`}
        >
          <div className="content">
            <HeaderList domain={domain} locale={locale} t={t} className="" />
          </div>
        </div>
      </div>
      <div
        className={`header_benefit_bar_wrapper ${
          scrollHeight > 32 ? "scrolled" : ""
        }`}
      >
        <BenefitsHeader />
      </div>
    </>
  );
};

const mapStateToProps = (state: stateType) => ({
  cart: state.cartReducer.cart,
  extras: state.cartReducer.extras
});

const mapDispatchToProps = (dispatch: any) => ({
  removeFromCart: (id: number, type: service_types) => {
    dispatch(removeFromCart(id, type));
  }
});

const ConnectedHeader = connect(mapStateToProps, mapDispatchToProps)(Header);

export default ConnectedHeader;

const HeaderList = ({
  className,
  domain,
  t,
  locale
}: {
  className: string;
  domain: string;
  t: (data: keyof typeof json) => string;
  locale: locale;
}) => {
  const service_link = getServiceLink(locale);
  return (
    <ul className={className}>
      <li>
        <Link to={`/${service_link}/cleaning-products`}>Cleaning Products</Link>
      </li>

      <li>
        <a href={`http://${domain}/${t("Before & After Link")}/`}>
          {t("Before & After")}
        </a>
      </li>
      {locale === "lt" ? (
        <>
          <li>
            <a href={`https://${domain}/${t("Support Link")}/`}>
              {t("Support")}
              <span className="ukr_flag_span">
                <UKR />
              </span>
            </a>
          </li>
          <li>
            <a href={`https://${domain}/${t("About us Link")}/`}>
              {t("About us")}
            </a>
          </li>
        </>
      ) : (
        <>
          <li>
            <a href={`https://${domain}/commercial/`}>{t("Commercial")}</a>
          </li>
          <li>
            <a href={`https://${domain}/careers/`}>{t("Careers")}</a>
          </li>
        </>
      )}
      <li>
        <a href={`https://${domain}/${t("Help Link")}/`}>{t("Help")}</a>
      </li>
    </ul>
  );
};
